/* eslint-disable no-use-before-define,no-mixed-operators */
import { readCookies } from './cookie'

export const getConfig = (key, defaultValue) => {
    let cfg = (global.app || {}).config || {}
    let keys = (key || '.').split('.')
    for (let i=0, n=keys.length; i<n; i++) {
        let k = keys[i]
        cfg = cfg[k]
        if (cfg===undefined || cfg===null) break
    }
    return (cfg===undefined || cfg===null)
        ? defaultValue
        : cfg
}

export const setConfig = (values) => {
    let cfg = (global.app || {}).config || {}
    return Object.assign(cfg, values)
}

export const getBrand = () => {
    return getConfig('user.Brand')
        || readCookies()['last-login-brand']
}

export const getSessionId = () => {
    return getConfig('user.SessionId')
        || readCookies()[getBrand() + '-si']
}

export const getUserId = () => {
    return getConfig('user.UserId')
}

export const getEnvironment = () => {
    return window.location.host.split('.').shift()[2].toUpperCase()
}

export const getParm = (key, defaultValue) => {
    let cfg = (global.app || {}).config || {}
    let ps = cfg['parm'] || {}
    return (key in ps) ? ps[key] : defaultValue
}

let services
export const hasSvc = (key) => {
    if (!services) {
        let cfg = global.app && global.app.config
        services = cfg && cfg.user && cfg.user.Services && cfg.user.Services.Service
            || []
    }
    return services.indexOf(key) >= 0
}

export const getUserParm = (name, dv) => {
    const p = getConfig('user.UserParms', {Parm:[]}).Parm
        .filter(({Name}) => Name===name)[0]
    return p ? p.Value : dv
}

export const setUserParm = (name, Value) => {
    const ps = getConfig('user.UserParms', {Parm:[]}).Parm
    const p = ps.filter(({Name}) => Name===name)[0]
    if (!p) {
        ps.push({Name:name, Value})
    } else {
        p.Value = Value
    }
}

export const deleteUserParm = (name) => {
    const ps = getConfig('user.UserParms', {})
    ps.Parm = (ps.Parm || []).filter(({Name}) => Name!==name)
}

export const getOwaTcdaoContext = () => {
    let owaTcDaoContext = getConfig('entitlements.EnableOwaToTcdao', 'No') === 'Yes'
    return owaTcDaoContext ? 'servlet/tcdao' : 'owa'
}